<div class="wrapper container-xl" *ngIf="currentPage!='/login'&&!isHomePage;else loginPage">
  <dashboard-nav></dashboard-nav>
  <div class="row m-0" style="height: calc(100vh - 69px);">
    <div class="col-12 col-md-4 col-lg-2 pl-0 pr-0">
      <app-menu ></app-menu>
    </div>
    <div class="col-12 col-md-8 col-lg-10" style="max-height: 100%; overflow-y: auto;">
        <router-outlet></router-outlet>
    </div>  
  </div>
</div>
<ng-template #loginPage>

  <router-outlet></router-outlet>
</ng-template>
